import React, { useEffect, useState } from 'react';
import { Typography, Card, Button, Spin, message } from 'antd';
import { useAccount, useClient } from 'wagmi';
import { useNavigate } from 'react-router-dom';
import { signMessage } from '@wagmi/core'; 
import ConnectWalletButton from '../components/ConnectWalletButton';
import { wagmiConfig } from "../web3Config";
import '../styles/LoginPage.css';

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const { isConnected, address, connector } = useAccount(); 
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isConnected && address) {
      // Auto login if wallet is connected
      handleLogin(address);
    }
  }, [isConnected, address]);

  const handleLogin = async (walletAddress: string) => {
    if (!connector) {
      message.error("Connector is not available");
      return;
    }

    try {
      setLoading(true);

      // Generate the message to sign
      const timestamp = Date.now();
      const messageToSign = `mobius:${timestamp}`;
      
      // Sign the message using the connector
      const signedMessage = await signMessage(wagmiConfig, {
        connector, // Use the connector
        message: messageToSign, // Message to sign
      });

      // Make the API call to login
      const response = await fetch("https://mobius.hipple.io/api/v1/login/wallet", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          address: walletAddress,
          message: messageToSign,
          signature: signedMessage, // Use the signed message
        })
      });

      const data = await response.json();

      if (data.error === 0) {
        // Successfully logged in, save token and navigate
        localStorage.setItem('authToken', data.data.token);
        navigate('/dashboard');
      } else {
        message.error("Login failed: " + data.message);
      }
    } catch (error) {
      console.error("Login error", error);
      message.error("Error during login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Card className="login-card">
        <Title level={2} className="login-title">
          Welcome to dSoftGames
        </Title>
        <Text type="secondary" className="login-subtitle">
          Connect your wallet to continue
        </Text>
        <div style={{ marginTop: '1.5rem' }}>
          {!isConnected ? (
            <ConnectWalletButton />
          ) : (
            <Button
              type="primary"
              onClick={() => handleLogin(address!)}
              loading={loading}
              disabled={loading}
            >
              {loading ? <Spin /> : "Login"}
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
